/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { ApplyPanelDataModule } from './apply-panel-data.module';
export { ApplyPanelDataComponent } from './apply-panel-data.component';